import { LazyLoadImage } from 'react-lazy-load-image-component';

import useStyles from './storeLinksStyles';
import { STORE_LINKS } from './config';
import { StoreLinksProps } from './types';

export function StoreLinks({ onClick }: StoreLinksProps) {
  const classes = useStyles();

  return (
    <section className={classes.root}>
      <a className={classes.logo} href="https://tools.picsart.com">
        <LazyLoadImage
          width="119"
          height="28"
          src="https://pastatic.picsart.com/cms-pastatic/3da995f6-de33-4264-ba8c-f0413711027a.png"
          alt="Quicktools Logo"
        />
      </a>

      <p className={classes.text}>Get the free Picsart app</p>

      <ul className={classes.row}>
        {STORE_LINKS.map(
          ({ href, imgSrc, rel, target, width, height, analyticsActionType, alt }) => (
            <li key={href} className={classes.item}>
              <a href={href} target={target} rel={rel} className={classes.imgContainer}>
                <LazyLoadImage
                  alt={alt}
                  className={classes.img}
                  width={width}
                  height={height}
                  src={imgSrc}
                  onClick={() => onClick(analyticsActionType)}
                />
              </a>
            </li>
          ),
        )}
      </ul>
    </section>
  );
}
